import { CITY_SLUG } from 'dpl/constants/query_params';

export function puppiesResourceDefinition(
  breedId,
  itemsPerPage,
  currentPage,
  filters
) {
  return {
    url: `/api/breeds/${breedId}/puppies.json`,
    params: {
      per_page: itemsPerPage,
      page: currentPage,
      ...filters
    },
    defaultValue: {
      meta: {
        available_delivery_methods: []
      },
      data: []
    }
  };
}

export function puppyAndBreederCountsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/puppy_and_breeder_counts.json`,
    params: {
      ...filters
    }
  };
}

// Also the eligibility check, so control runs it too. `results_type` is not
// sent: the server picks the serialization from the arm it just assigned.
// `placeholder_color` matches the white card, not the sand band behind it.
export function similarBreedResultsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/similar_breed_results.json`,
    params: { ...filters, placeholder_color: 'white' },
    defaultValue: {
      meta: { variant: 'control' },
      data: {}
    }
  };
}

// The "See all" overlay's results: the same selection the module renders, a
// page at a time and with richer cards. `results_type` is sent here, unlike in
// the module's definition, where the server picks it from the arm it assigned.
export function similarBreedSeeAllResultsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/similar_breed_results/see_all.json`,
    params: { ...filters, placeholder_color: 'white' },
    defaultValue: {
      meta: {},
      data: {}
    }
  };
}

export function nearbyBreederProfilesResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/nearby_breeder_profiles.json`,
    params: filters
  };
}

export function nearbyOwnerStoriesResourceDefinition(breedId, citySlug) {
  return {
    url: `/api/breeds/${breedId}/nearby_owner_stories.json`,
    params: { [CITY_SLUG]: citySlug },
    defaultValue: { data: [] }
  };
}

export function newsletterSignupMutationDefinition() {
  return {
    url: '/api/email_list_registrations.json',
    method: 'POST'
  };
}
